import "./App.css";
import React, { createContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GetAllPipelines from "./components/getAllPipelines/getAllPipelines";
import GetAllLookUpData from "./components/getAllLookUpData/LookUpScreen";
import Home from "./components/Home/home";
import UpdatePipeline from "./components/updatePipeline/updatePipeline";
import UpdateLookup from "./components/updateLookUp/updateLookUp";
import { PageLayout } from "./components/Navbar/PageLayout";
import { useState } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { locationContext } from "./Context/CustomContext";


const Pages = () => {
  return (
    <>
   
      <AuthenticatedTemplate>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/getallpipelines" element={<GetAllPipelines />} />
            <Route path="/getalllookupdata" element={<GetAllLookUpData />} />
            <Route path ="/getallpipelines/edit-pipeline" element={<UpdatePipeline/>}/>
            <Route path ="/getalllookupdata/edit-lookup" element={<UpdateLookup/>}/>
          </Routes>
        </Router>
      </AuthenticatedTemplate>
  
      <UnauthenticatedTemplate>
        <div>
          <div className="content">
            <Router>
              <Routes>
                <Route exact path="/" element={<Home />} />
              </Routes>
            </Router>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
};
function App() {
  const [currentLocation, setCurrentLocation] = useState(null);
  return (
    <locationContext.Provider value={{ currentLocation, setCurrentLocation }}>
      <PageLayout>
        <Pages />
      </PageLayout>
    </locationContext.Provider>
  );
}

export default App;
